import Container from 'components/molecules/Container/Container';
import { useStartEnglishProficiencyAssessmentMutation } from 'generated/graphql';
import { FC, useEffect } from 'react';
import {
  Loader,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import EnglishProficiencyTest from 'views/Test/Tests/EnglishProficiencyTest/EnglishProficiencyTest';

interface IEnglishProficiencyTestRunner {
  /** The stage action candidate, not the qcalc sitting. */
  actionCandidateId: string;
  onFinishTest: () => void;
}

/**
 * Turns a stage action candidate into a sitting.
 *
 * Starting is what sets the deadline, so the monolith hands back the existing
 * sitting rather than issuing a second one — which means a candidate coming
 * back to an unfinished test lands here again and keeps the hour they had
 * left, not a fresh one.
 */
const EnglishProficiencyTestRunner: FC<IEnglishProficiencyTestRunner> = ({
  actionCandidateId,
  onFinishTest,
}) => {
  const { handleMsgType } = useNotification();

  const [startAssessment, startAssessmentResponse] =
    useStartEnglishProficiencyAssessmentMutation({
      variables: { id: actionCandidateId },
      onError: error => {
        handleMsgType({ type: TNotification.error, message: error?.message });
      },
    });

  useEffect(() => {
    void startAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const assessmentId =
    startAssessmentResponse.data?.startEnglishProficiencyAssessment
      .assessmentId;

  if (startAssessmentResponse.loading) {
    return (
      <Container className="page-loader-wrapper">
        <Loader variant="bubbles" />
      </Container>
    );
  }

  if (!assessmentId) {
    return null;
  }

  return (
    <EnglishProficiencyTest
      assessmentId={assessmentId}
      onFinishTest={onFinishTest}
    />
  );
};

export default EnglishProficiencyTestRunner;
